import angular from 'angular';

import { accessLevels } from '../constants';
import orgFeatureStateGuard from '../account/orgFeatureStateGuard';
import { OLD_TASKS_TAB_NAME } from '../shiftTasks/constants';

import modalForm from './modal-form.html';
import EditTaskCtrl from './EditTaskCtrl';
import Tasks from './models/Tasks';
import TaskCollection_ from './models/TaskCollection';
import taskDirective from './directives/task';
import taskDraggable from './directives/taskDraggable';
import taskDropTarget from './directives/taskDropTarget';
import taskHistoryComponent from './components/taskHistoryComponent';
import TaskService from './services/TaskService';
import indexUrl from './index.html';
import TasksCtrl from './TasksCtrl';
import introductionUrl from './introduction.html';

const tasksModule = angular.module('sling.tasks', []);
export default tasksModule.name;

tasksModule.config(($stateProvider) => {
  $stateProvider.state('tasks', {
    url: '/tasks?notificationId',
    templateUrl: indexUrl,
    controller: TasksCtrl,
    controllerAs: 'ctrl',
    data: {
      title: 'Tasks',
      access: accessLevels.user,
    },
    resolve: {
      personaCollection(PersonaCollection, TaskCollection) {
        return PersonaCollection.loadData().then(() => TaskCollection.loadData());
      },
    },
    onEnter(
      Authentication,
      NotificationCollection,
      NotificationModal,
      ShiftTasksTabsService,
      RateService,
      $uibModal,
      $location,
      $timeout
    ) {
      RateService.triggerRateModal();
      /**
       * the async IIFE trick is used to not stall the loading of the state
       * otherwise if onEnter was async ui-router would wait until it resolves
       */
      (async () => {
        ShiftTasksTabsService.setTabByValue(OLD_TASKS_TAB_NAME);
        const { adminOnboardingCompleted, tasksHelpShown, onboardingComplete } =
          Authentication.user.settings;
        if (!tasksHelpShown && (onboardingComplete || adminOnboardingCompleted)) {
          await $uibModal
            .open({
              windowClass: 'sling-tour-modal sling-animate',
              templateUrl: introductionUrl,
            })
            .result.then(null, () => {
              Authentication.user.settings.tasksHelpShown = true;
              Authentication.syncSettings();
            });
        }

        await $timeout();
        const { notificationId } = $location.search();
        if (notificationId) {
          NotificationCollection.retrieveNotification(notificationId, {
            ignoreGlobalErrorHandler: true,
          }).then((notification) => {
            if (notification) {
              NotificationModal.openNotificationModal(notification);
            }
          });
        }
      })();
    },
  });

  $stateProvider.state('tasks.view', {
    url: '/{taskId:[0-9]+}',
    onEnter(personaCollection, $uibModal, $transition$, $state) {
      $uibModal
        .open({
          size: '620',
          templateUrl: modalForm,
          controller: EditTaskCtrl,
          controllerAs: 'ctrl',
          backdrop: 'static',
          resolve: {
            task(TaskCollection) {
              'ngInject';

              const result = TaskCollection.allTasks.find(
                (t) => String(t.id) === $transition$.params().taskId
              );
              if (result) {
                return TaskCollection.getTaskDetails(result);
              }

              $state.transitionTo('tasks');
            },
            notification() {
              return {};
            },
          },
        })
        .result.ignoreCancel()
        .finally(() => {
          $state.transitionTo('tasks');
        });
    },
  });

  $stateProvider.state('tasks.add', {
    url: '/add?my',
    onEnter(personaCollection, PersonaCollection, Authentication, $uibModal, $state, $transition$) {
      $uibModal
        .open({
          templateUrl: modalForm,
          controller: EditTaskCtrl,
          controllerAs: 'ctrl',
          size: '620',
          backdrop: 'static',
          resolve: {
            task() {
              const personas = [];

              if ($transition$.params().my === 'true') {
                personas.push(PersonaCollection.me);
              }

              return {
                personas,
                attachments: [],
                expand: false,
              };
            },
          },
        })
        .result.ignoreCancel()
        .finally(() => {
          $state.transitionTo('tasks');
        });
    },
  });
});

tasksModule.run(orgFeatureStateGuard('tasks'));

tasksModule.factory('Tasks', Tasks);

tasksModule.service('TaskCollection', TaskCollection_);

tasksModule.directive('task', taskDirective);
tasksModule.directive('taskDraggable', taskDraggable);
tasksModule.directive('taskDropTarget', taskDropTarget);
tasksModule.component('taskHistory', taskHistoryComponent);
tasksModule.service('TaskService', TaskService);
